/** SHA-256 of the original file bytes, as lowercase hex. */
export async function sha256Hex(file: Blob): Promise<string> {
  const data = await file.arrayBuffer();
  const digest = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}
